import Constants from '@/Constants';
import { analyticsService, BotEvents } from '@/services/AnalyticsService';
import BotService from '@/services/BotService';
import { contentService } from '@/services/ContentService';
import { ApplicationState } from '@/store';
import { sendNewEventRequest } from '@/store/bot/actions';
import { BotAction } from '@/store/bot/types';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface Props {
    closeNotification: Function;
}

const AskToFavoriteContentAction: React.FC<Props> = ({ closeNotification }: Props) => {
    const { strings, botAction, currentLearningMap } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        currentLearningMap: state.learningMap.data.currentLearningMap,
        botAction: state.chat.action as BotAction,
    }));

    const hasPendingRecommendation = useRef<boolean>(true);

    const dispatch = useDispatch();

    const doRecommendation = () => {
        const { content } = botAction;
        BotService.recommendContent(dispatch, content, currentLearningMap);
        dispatch(sendNewEventRequest(Constants.chatbotEvents.CHATBOT_CONTENT_RATING_5));
        hasPendingRecommendation.current = false;
    };

    const finishFavoriteAction = () => {
        doRecommendation();
        closeNotification();
    };

    const addToFavorite = () => {
        if (!botAction) return;

        const { content } = botAction;
        contentService.favoriteContent(dispatch, content);

        analyticsService.logEvent(BotEvents.FAVORITE_ITEM_CHAT, {
            entityId: content.id,
            entityName: content.name,
            entityType: Constants.entityTypes.CONTENT,
        });

        finishFavoriteAction();
    };

    useEffect(() => {
        return () => {
            if (hasPendingRecommendation.current) {
                doRecommendation();
            }
        };
    }, []);

    return (
        <>
            <p>{botAction.message}</p>
            <div className="chat-bot-action-buttons">
                <button className="no left" onClick={finishFavoriteAction}>
                    {strings.NO}
                </button>
                <button className="yes right" onClick={addToFavorite}>
                    {strings.YES}
                </button>
            </div>
        </>
    );
};

export default AskToFavoriteContentAction;
